module.exports = __webpack_public_path__ + "static/work57-a0aa8793cfb21e45036b61df743bfdbc.jpg";